import script from "./DropdownMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownMenu.vue?vue&type=script&setup=true&lang=ts"

import "./DropdownMenu.vue?vue&type=style&index=0&id=4a1143e5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a1143e5"]])

export default __exports__